"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportCategoryCircuitsDto = void 0;
class ImportCategoryCircuitsDto {
    categoryCircuits;
}
exports.ImportCategoryCircuitsDto = ImportCategoryCircuitsDto;
